import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { sortByNumericThenAlpha } from '@awp/helpers/sorter';
import Table from '@awp/components/table';
import { getUtcToLocalByFormat } from '@awp/helpers/utilsReact';
import { FormHorizontalTextReadOnly } from '@components/Common/AwpFormInputs';

function ProcessedHazardForecastMetricTable({ eventId, data }) {
  //const currentUser = useSelector(selectCurrentUser);
  const [mode, setMode] = useState('');
  const [item, setItem] = useState();
  const [showModal, setShowModal] = useState(false);
  const [showConfirm, setConfirm] = useState(false);

  const getStatus = (value) => {
    return (value + '').toUpperCase() == 'U'
      ? 'Pending'
      : (value + '').toUpperCase() == 'Y'
      ? 'Sent'
      : (value + '').toUpperCase() == 'N'
      ? 'Failed'
      : '';
  };
  const columns = useMemo(
    () => [
      {
        Header: 'Recipient',
        accessor: 'RecipientDisplayName',
        sortType: sortByNumericThenAlpha,
        Cell: ({ value }) => {
          return value;
        },
      },
      {
        Header: 'Delivery Method',
        accessor: 'Method',
        sortType: sortByNumericThenAlpha,
      },
      {
        Header: 'Date Sent',
        accessor: 'LastUpdateTimestamp',
        sortType: sortByNumericThenAlpha,
        Cell: ({ value }) => {
          return getUtcToLocalByFormat(value, 'yyyy-MM-dd HH:mm:ss');
        },
      },
      {
        Header: 'Status',
        accessor: 'DeliveryStatus',
        sortType: sortByNumericThenAlpha,
      },
      {
        Header: 'Failure Reason',
        accessor: 'FailureReason',
        sortType: sortByNumericThenAlpha,
      },
    ],
    [],
  );

  return (
    <>
      <FormHorizontalTextReadOnly label="Total Recipients:" textValue={data.TotalRecipients} />
      <FormHorizontalTextReadOnly label="Total Sent:" textValue={data.TotalSent} />
      <FormHorizontalTextReadOnly label="Successful/Failed:" textValue={''} />
      <FormHorizontalTextReadOnly label="Email:" textValue={data.EmailStats} isBold={false} />
      <FormHorizontalTextReadOnly label="SMS:" textValue={data.SmsStats} isBold={false} />
      <FormHorizontalTextReadOnly label="FAX:" textValue={data.FaxStats} isBold={false} />

      <Table
        id="third_party_forecast_table"
        columns={columns}
        data={data.NotificationRecipientMetrics || []}
        fetchData={() => {}}
        loading={false}
        search={[]}
        filters={[]}
        dataTriggers={[]}
      />
    </>
  );
}

ProcessedHazardForecastMetricTable.propTypes = {
  eventId: PropTypes.any.isRequired,
  data: PropTypes.object,
};

export default ProcessedHazardForecastMetricTable;
